import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { usePrivacyPolicy } from '@/hooks/useCompliance'
import { formatDate } from '@/lib/format'

// 2.13.2 — Privacy policy page. Read-only policy text + last-updated date.
export default function PrivacyPolicyPage() {
  const { t } = useTranslation('compliance')
  const navigate = useNavigate()
  const { data, isLoading, isError } = usePrivacyPolicy()
  const policy = data?.data

  function goBack() {
    const historyIndex = window.history.state?.idx
    if (typeof historyIndex === 'number' && historyIndex > 0) {
      navigate(-1)
    } else {
      navigate('/dashboard', { replace: true })
    }
  }

  return (
    <div className='mx-auto max-w-3xl space-y-6 pt-6'>
      <header className='flex items-center gap-3'>
        <Button
          variant='ghost'
          size='icon'
          aria-label={t('privacyPolicy.back')}
          onClick={goBack}
        >
          <ArrowLeft className='h-5 w-5' />
        </Button>
        <h1 className='text-2xl font-bold tracking-tight'>
          {t('privacyPolicy.title')}
        </h1>
      </header>

      <Card>
        <CardContent className='space-y-4 pt-6'>
          {isLoading ? (
            <Skeleton className='h-64 w-full' />
          ) : isError ? (
            <p className='py-8 text-center text-sm text-destructive'>
              {t('privacyPolicy.loadError')}
            </p>
          ) : (
            <>
              {policy?.updated_at && (
                <p className='text-sm text-muted-foreground'>
                  {t('privacyPolicy.lastUpdated', {
                    date: formatDate(policy.updated_at),
                  })}
                  {policy.version &&
                    t('privacyPolicy.version', { version: policy.version })}
                </p>
              )}
              <div className='prose prose-sm max-w-none whitespace-pre-wrap text-sm leading-relaxed text-foreground'>
                {policy?.content || t('privacyPolicy.placeholder')}
              </div>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  )
}
